import { RecipeParameterKind } from './recipe-parameters.model';

/**
 * A placeholder GFE is willing to offer an admin, and the vocabulary for it.
 *
 * The catalogue exists because the data layer deliberately ships no
 * translations for parameter names: a parameter is admin-authored data, not
 * data-layer vocabulary. It emits a humanized `title` as a floor and nothing
 * more, so GFE owns every localized caption.
 */
export interface RecipeParameterCatalogueEntry {
  name: string;
  kind: RecipeParameterKind;
  labelKey: string;
  descriptionKey: string;
}

const entry = (name: string, kind: RecipeParameterKind): RecipeParameterCatalogueEntry => ({
  name,
  kind,
  labelKey: `recipe_parameters.catalogue.${name}.label`,
  descriptionKey: `recipe_parameters.catalogue.${name}.description`
});

export const RECIPE_PARAMETER_CATALOGUE: Record<string, RecipeParameterCatalogueEntry> = {
  target_date: entry('target_date', 'date'),
  zones: entry('zones', 'list')
};

export function catalogueEntry(name: string): RecipeParameterCatalogueEntry | undefined {
  return RECIPE_PARAMETER_CATALOGUE[name];
}

/**
 * The entries offerable in a slot of the given kind. Filtering by kind is what
 * stops an admin dropping a date parameter into a tag slot, which the data
 * layer cannot catch because the name means nothing to it.
 */
export function catalogueEntriesForKind(
  kind: RecipeParameterKind
): RecipeParameterCatalogueEntry[] {
  return Object.values(RECIPE_PARAMETER_CATALOGUE).filter((e) => e.kind === kind);
}
